import React, { useEffect, useState, useRef } from 'react';
import { KTSVG, KTIcon } from '../../_metronic/helpers';
import fetchAPI from '../../common/fetchAPI';
import moment from 'moment';
import { useReactToPrint } from 'react-to-print';
import TimesheetPrintWidget from './TimesheetPrintWidget';
import { useAppDispatch, useAppSelector } from '../../app/hooks';
import { displayValueForTimeEntry, getColumnSum } from '../../common/timesheetFunction';
import { t } from 'i18next';
import { updateTimeEntryPeriodIdForPrint, getEmployeeAsync, updateRefreshPrint } from '../timesheet/timesheetSlice';
import { getAndSetCustomFieldValues, formatDateWithDateAndMonthName, FormatInvoiceDecimalNumber, getValueFromResource } from '../../common/timeLiveFunction';
import { Link, useLocation, useNavigate } from "react-router-dom";
import { format, parse } from 'date-fns';

const objRecords = {
    timeEntryDetailArray: [],
    dateHeaderArray: [],
    datePrintHeaderArray: [],
    commentsArray: [],
    accountEmployeeId: 0,
    totalHoursGlobal: 0,
    isLoading: true,
    logoPath: '',
    eSignURL: '',
    timeentryEmployeeName: '',
    timesheetDate: '',
    status:''
}

const TimesheetPrintViewWidget = (props: any) => {
    const dispatch = useAppDispatch();
    const location = useLocation();
    const { modelRef, showDecimal } = props;
    const componentRef = useRef<HTMLDivElement>(null);
    const { accountEmployeeId, startDate, endDate, timeEntryViewType, employeeList, timesheetStatus, totalHours, isTimesheetPolicy, 
        timeEntryPeriodIdForPrint, isForTimesheet, systemApproverTypeForPrint, startDateForPrint, endDateForPrint, rowAccountEmployeeIdForPrint, refreshPrint, approvalEmployeeName } = useAppSelector((state) => state.timesheet);
    const { cultureInfoName, sessionAccountEmployeeId, showTimeOffInTimesheet, isCompanyOwnLogo, isShowElectronicSign, CurrentCultureDateFormat, decimalPlaces, HighlightTimeEntriesBy,decimalFormat } = useAppSelector(state => state.globalState);
    const [timeEntriesDetail, setTimeEntriesDetail] = useState<any | ''>(objRecords);
    const [showAll, setShowAll] = useState(false);
        const [customFieldsArray, SetCustomFieldsArray] = useState<any | ''>([]);
     

    useEffect(() => {
        if (employeeList.length === 0) {
            dispatch(getEmployeeAsync());
        }
    }, []);

    const GetTimeEntriesDetail = () => {
        setTimeEntriesDetail({
            ...timeEntriesDetail,
            timeEntryDetailArray: [],
            dateHeaderArray: [],
            datePrintHeaderArray: [],
            commentsArray: [],
            accountEmployeeId: 0,
            isLoading: true,
            logoPath: '',
            eSignURL: ''
        });
        if (timeEntryPeriodIdForPrint && isForTimesheet) {
            getTimeEntriesDetailRecords().then((result) => {
            }).catch((error) => {

            });
        }
        else if ((timeEntryPeriodIdForPrint || showAll) && !isForTimesheet) {
            getTimeEntriesDetailRecordsForApproval(showAll, systemApproverTypeForPrint.split(" ").join(''), startDateForPrint, endDateForPrint, rowAccountEmployeeIdForPrint, sessionAccountEmployeeId.toString()).then((result) => {
            }).catch((error) => {

            });
        } else {
            setTimeEntriesDetail({
                ...timeEntriesDetail,
                isLoading: false
            });
        }
    }
    useEffect(() => {
        GetTimeEntriesDetail();
        // setTimeEntriesDetail({
        //     ...timeEntriesDetail,
        //     timeEntryDetailArray: [],
        //     dateHeaderArray: [],
        //     datePrintHeaderArray: [],
        //     commentsArray: [],
        //     accountEmployeeId: 0,
        //     isLoading: true
        // });
        // if (timeEntryPeriodIdForPrint && isForTimesheet) {
        //     getTimeEntriesDetailRecords().then((result) => {
        //     }).catch((error) => {

        //     });
        // }
        // else if ((timeEntryPeriodIdForPrint || showAll) && !isForTimesheet) {
        //     getTimeEntriesDetailRecordsForApproval(showAll, systemApproverTypeForPrint.split(" ").join(''), startDateForPrint, endDateForPrint, rowAccountEmployeeIdForPrint, sessionAccountEmployeeId.toString()).then((result) => {
        //     }).catch((error) => {

        //     });
        // } else {
        //     setTimeEntriesDetail({
        //         ...timeEntriesDetail,
        //         isLoading: false
        //     });
        // }
    }, [timeEntryPeriodIdForPrint, showAll])

    useEffect(() => {
        if (refreshPrint) {
            GetTimeEntriesDetail();
            dispatch(updateRefreshPrint(false));
        }
    }, [refreshPrint])

    useEffect(() => {
        getCustomFieldTemplateByMasterEntityTypeIdAsync();
    }, [])

    const getCustomFieldTemplateByMasterEntityTypeIdAsync = async () => {
        let MasterEntityTypeId = '369ED0FB-D317-4244-9F20-B7D834521E2B';
        const response = await fetchAPI('api/v2/CustomFields/CustomFieldTemplateByMasterEntityType/' + MasterEntityTypeId, 'GET', '', true, "");
        const json = await response.json();
        if (json.length > 0) {
            SetCustomFieldsArray(json);
        }
        else {
            SetCustomFieldsArray([]);
        }
        return json;
    }

    const getTimeEntriesDetailRecords = async () => {
        const response = await fetchAPI(`api/Timesheets/GetAccountApprovalTimesheetsWithComments/${accountEmployeeId}/${startDate}/${timeEntryViewType}/''/${true}/${0}/${accountEmployeeId}/${isCompanyOwnLogo}/${isShowElectronicSign}`, 'Get', '', true);
        const json = await response.json();
        let totalHoursSum = 0;
        let timeEntryRows = [];
        for (var i = 0; i < json["0"].length; i++) {
            let obj = json["0"][i];
            let timeEntryRow = {
                rowId: i,
                // partyName: obj.PartyName !== undefined ? obj.PartyName : obj.ClientName,
                partyName: obj.hasOwnProperty('PartyName') ? obj.PartyName : obj.ClientName,
                projectName: obj.ProjectName,
                taskName: obj.TaskName,
                accountCostCenter: obj.AccountCostCenter,
                accountTimeOffType: obj.AccountTimeOffType,
                accountTimeOffTypeId: obj.AccountTimeOffTypeId,
                timeType: obj.TimeType,
                timeEntries: [] as any,
                totalHours: 0,
                isTimeOff: obj.IsTimeOff,
                submittedByName: obj.SubmittedByName,
                submittedDate: obj.SubmittedDate
            };
            if (obj.IsTimeOff === false) {
                for (var key in obj) {
                    let timeEntryDetail = {
                        rowId: i,
                        Hours: ''
                    }
                    if (key.match(/^Hours/)) {
                        timeEntryDetail.Hours = obj[key] ? obj[key] : 0;
                        totalHoursSum += parseFloat(timeEntryDetail.Hours);
                        timeEntryRow.totalHours += parseFloat(timeEntryDetail.Hours);
                        timeEntryRow.timeEntries.push(timeEntryDetail);
                    }
                }
                timeEntryRows.push(timeEntryRow)
            } else {
                if (showTimeOffInTimesheet) {
                    for (var key in obj) {
                        let timeEntryDetail = {
                            rowId: i,
                            Hours: ''
                        }
                        if (key.match(/^Hours/)) {
                            timeEntryDetail.Hours = obj[key] ? obj[key] : 0;
                            totalHoursSum += parseFloat(timeEntryDetail.Hours);
                            timeEntryRow.totalHours += parseFloat(timeEntryDetail.Hours);
                            timeEntryRow.timeEntries.push(timeEntryDetail);
                        }
                    }
                    timeEntryRows.push(timeEntryRow)
                }
            }
        }
        let tempCommentArray: any[] = []
        json["1"].map((item: any) => {
            if (item.IsTimeOff === false) {
                tempCommentArray.push(item)
            } else {
                if (showTimeOffInTimesheet) {
                    tempCommentArray.push(item)
                }
            }
        })
        setTimeEntriesDetail({
            ...timeEntriesDetail,
            timeEntryDetailArray: timeEntryRows,
            dateHeaderArray: json["2"],
            datePrintHeaderArray: json["2"],
            // commentsArray: json["1"],
            commentsArray: tempCommentArray,
            // accountEmployeeId: json["1"][0].AccountEmployeeId
            accountEmployeeId: json["1"].length > 0 ? json["1"][0].AccountEmployeeId : accountEmployeeId,
            isLoading: false,
            totalHoursGlobal: totalHoursSum,
            logoPath: json["3"],
            eSignURL: json["4"]
        });
    }

    const getTimeEntriesDetailRecordsForApproval = async (showAll: boolean, systemapprovertype: string, startDateForPrint: string, endDate: string, accountEmployeeIdRows: number, approverEmployeeId: string) => {
        const response = await fetchAPI(`api/Timesheets/GetAccountApprovalTimesheetsWithComments/${accountEmployeeIdRows}/${startDateForPrint}/${timeEntryViewType}/${systemapprovertype.trim()}/${showAll ? true : false}/${0}/${approverEmployeeId}/${isCompanyOwnLogo}/${isShowElectronicSign}`, 'Get', '', true);
        const json = await response.json();
        let isStatus = json[0][0].IsPeriodSubmitted;
        let timeEntryRows = [];
        let totalHoursSum = 0;
        for (var i = 0; i < json["0"].length; i++) {
            let obj = json["0"][i];
            let timeEntryRow = {
                rowId: i,
                // partyName: obj.PartyName !== undefined ? obj.PartyName : obj.ClientName,
                partyName: obj.hasOwnProperty('PartyName') ? obj.PartyName : obj.ClientName,
                projectName: obj.ProjectName,
                taskName: obj.TaskName,
                accountCostCenter: obj.AccountCostCenter,
                accountTimeOffType: obj.AccountTimeOffType,
                accountTimeOffTypeId: obj.AccountTimeOffTypeId,
                timeType: obj.TimeType,
                timeEntries: [] as any,
                totalHours: 0,
                submittedByName: obj.SubmittedByName,
                submittedDate: obj.SubmittedDate,
                employeeName: obj.EmployeeName,
                timesheetDate: formatDateWithDateAndMonthName(startDateForPrint, cultureInfoName.toString()) + ' - ' + formatDateWithDateAndMonthName(endDateForPrint, cultureInfoName.toString())
            };
            for (var key in obj) {
                let timeEntryDetail = {
                    rowId: i,
                    Hours: ''
                }
                if (key.match(/^Hours/)) {
                    timeEntryDetail.Hours = obj[key] ? obj[key] : 0;
                    totalHoursSum += parseFloat(timeEntryDetail.Hours);
                    timeEntryRow.totalHours += parseFloat(timeEntryDetail.Hours);
                    timeEntryRow.timeEntries.push(timeEntryDetail);
                }
            }
            timeEntryRows.push(timeEntryRow)
        }
        setTimeEntriesDetail({
            ...timeEntriesDetail,
            timeEntryDetailArray: timeEntryRows,
            dateHeaderArray: json["2"],
            datePrintHeaderArray: json["2"],
            commentsArray: json["1"],
            accountEmployeeId: json["1"].length > 0 ? json["1"][0].AccountEmployeeId : rowAccountEmployeeIdForPrint,
            totalHoursGlobal: totalHoursSum,
            isLoading: false,
            logoPath: json["3"],
            eSignURL: json["4"],
            status: isStatus ? 'Submitted' : 'Not Submitted'
        });
    }

    const handlePrint = useReactToPrint({
        content: () => componentRef.current
    });

    const handleCheckboxChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setShowAll(e.target.checked);
    }

    let captionFieldsArray: any;
    if (timeEntriesDetail.commentsArray.length > 0) {
        captionFieldsArray = Object.entries(timeEntriesDetail.commentsArray[0])
            .filter(([key, value]) => key.startsWith("CaptionCustomField"))
            .map(([key, value]) => ({ [key]: value }));
    }
    const handleCloseOnClickEvent = () => {
        if (location.pathname === "/timesheet") {
            dispatch(updateTimeEntryPeriodIdForPrint({ isForTimesheet: true }));
        } else {
            dispatch(updateTimeEntryPeriodIdForPrint({ isForTimesheet: false }));
        }
    }
    return (
        <>
            <div className='modal drawer-overlay' tabIndex={-1} data-bs-backdrop="false" id='timesheetPrintModal' role="dialog" aria-labelledby="exampleModalSizeSm" aria-hidden="true">
                <div className='modal-dialog modal-xl'>
                    <div className='modal-content rounded'>
                        <div className='modal-header pb-2'>
                            <h3 className='modalheaderTitle'>
                                {/* {t('Time Entry Week View')} */}
                                {getValueFromResource('Timesheet Detail', dispatch, t)}
                            </h3>
                            <div className='btn btn-sm btn-icon btn-active-color-primary' data-bs-dismiss='modal'
                                onClick={() => handleCloseOnClickEvent()}
                            >
                                <KTIcon iconName='cross' className='fs-1' />
                            </div>
                        </div>
                        <div className='modal-body pt-0 pb-15 px-5 px-xl-5' style={{ overflowY: 'auto', maxHeight: 'calc(100vh - 300px)' }}>
                            {timeEntriesDetail.isLoading ? <div className="d-flex justify-content-center align-items-center">
                                <span className='indicator-progress' style={{ display: 'block' }}>
                                    <span className='spinner-border spinner-border-md ms-2 mt-12'></span>
                                </span>
                            </div> :
                                <>
                                    <div className='row text-center mb-13' style={{ marginTop: 14 }}>
                                        <div className='col-md-3 col-sm-3 col-xs-12'>
                                            <span className='tsDetailModalLabel' style={{ paddingLeft: 0 }}>
                                                {/* {t('Employee Name:')} */}
                                                {getValueFromResource('Employee Name:', dispatch, t)}
                                            </span><br />
                                            {/* {isForTimesheet ? <span className='tsDetailModalText'>{accountEmployeeId > 0 && employeeList.filter(x => x.AccountEmployeeId == accountEmployeeId.toString())[0].EmployeeName}</span> :
                                                <span className='tsDetailModalText'>{timeEntriesDetail.accountEmployeeId > 0 && employeeList.filter(x => x.AccountEmployeeId == timeEntriesDetail.accountEmployeeId)[0].EmployeeName}</span>} */}
                                                {isForTimesheet ? <span className='tsDetailModalText'>{accountEmployeeId > 0 && employeeList.filter(x => x.AccountEmployeeId == accountEmployeeId.toString())[0].EmployeeName}</span> :
                                                <span className='tsDetailModalText'>{approvalEmployeeName}</span>}
                                        </div>
                                        {isForTimesheet ? <div className='col-md-3 col-sm-3 col-xs-12'>
                                            <span className='tsDetailModalLabel'>
                                                {/* {t('Timesheet Date')} */}
                                                {getValueFromResource('Timesheet Date', dispatch, t)}
                                            </span><br />
                                            <span className='tsDetailModalText'>{`${formatDateWithDateAndMonthName(startDate, cultureInfoName.toString())}  -  ${formatDateWithDateAndMonthName(endDate, cultureInfoName.toString())}`}</span>
                                        </div> :
                                            <div className='col-md-3 col-sm-3 col-xs-12'>
                                                <span className='tsDetailModalLabel'>{t('Timesheet Date')}</span><br />
                                                {/* <span className='tsDetailModalText'>{`${formatDateWithDateAndMonthName(props.startDate)}  -  ${formatDateWithDateAndMonthName(props.endDate)}`}</span> */}
                                                <span className='tsDetailModalText'>{`${formatDateWithDateAndMonthName(startDateForPrint, cultureInfoName.toString())}  -  ${formatDateWithDateAndMonthName(endDateForPrint, cultureInfoName.toString())}`}</span>
                                            </div>
                                        }
                                        {isForTimesheet ? <div className='col-md-3 col-sm-3 col-xs-12'>
                                            <span className='tsDetailModalLabel'>
                                                {/* {t('Timesheet Status')} */}
                                                {getValueFromResource('Timesheet Status', dispatch, t)}
                                            </span><br />
                                            <span className="tsDetailModalText">
                                                {(timeEntryPeriodIdForPrint || showAll) && !isForTimesheet
                                                    ? timeEntriesDetail.status
                                                    : timesheetStatus.text}
                                                   
                                            </span>

                                        </div> :
                                            <div className='col-md-3 col-sm-3 col-xs-12'>
                                                <span className='tsDetailModalLabel'>
                                                    {/* {t('Show All')} */}
                                                    {getValueFromResource('Show All', dispatch, t)}
                                                </span><br />
                                                <div className="form-check form-switch form-check-custom" style={{ justifyContent: 'center' }}>
                                                    <input
                                                        type="checkbox"
                                                        className="form-check-input custom-padding-right h-15px w-30px"
                                                        checked={showAll}
                                                        onChange={(e) => { handleCheckboxChange(e) }}
                                                    />
                                                </div>
                                            </div>
                                        }
                                        {isForTimesheet ? <div className='col-md-3 col-sm-3 col-xs-12'>
                                            <span className='tsDetailModalLabel'>
                                                {/* {t('Total Hours')} */}
                                                {getValueFromResource('Total Hours', dispatch, t)}
                                            </span><br />
                                            {/* <span className='tsDetailModalText'>{timeEntriesDetail.totalHoursGlobal}</span> */}
                                            <span className="tsNavBarInfoText" style={{ fontSize: '14px' }}>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(totalHours), 2) : totalHours}</span>
                                        </div> :
                                            <div className='col-md-3 col-sm-3 col-xs-12'>
                                                <span className='tsDetailModalLabel'>
                                                    {getValueFromResource('Total Hours', dispatch, t)}
                                                </span><br />
                                               <span className="tsNavBarInfoText">
                                                {/* {timeEntriesDetail.totalHoursGlobal?.toFixed(decimalPlaces)} */}
                                                {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(),  Number(timeEntriesDetail.totalHoursGlobal), 2) : displayValueForTimeEntry(timeEntriesDetail.totalHoursGlobal, false, showDecimal)}
                                                </span>
                                                {/* <span className="tsNavBarInfoText">{totalHours}</span> */}
                                                

                                            </div>
                                        }
                                    </div>
                                    <div className='tableContainer'>
                                        <div className='tsDetailTableMainDiv'>
                                            <table style={{ width: '100%', maxWidth: '100%' }}>
                                                <thead>
                                                    <tr>
                                                        <th className='tsDetailTableThead'>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {timeEntriesDetail.timeEntryDetailArray.length > 0 && timeEntriesDetail.timeEntryDetailArray.map((item: any, index: number) => (
                                                        <tr key={index}>
                                                            <td className='tsReportInfoTbody'>
                                                                {(item.timeType != null && item.timeType === 'Time Off' && showTimeOffInTimesheet) ? (
                                                                    <span className='tsReportInfoSpan'>
                                                                        {item.timeType + ' • ' + item.accountTimeOffType}
                                                                    </span>
                                                                ) : (
                                                                    <>
                                                                    {HighlightTimeEntriesBy === 'Client' ? (
                                                                        <>
                                                                        <span className="projectTaskHeading">{item.partyName}</span><br />
                                                                        <span className='tsReportInfoSpan'>
                                                                            {(item.accountCostCenter != null) ? item.projectName + ' • ' + item.taskName + ' • ' + item.accountCostCenter :
                                                                                item.projectName + ' • ' + item.taskName}
                                                                        </span>
                                                                        </>
                                                                    ) : (
                                                                        <>
                                                                        <span className="projectTaskHeading">{item.taskName}</span><br />
                                                                        <span className='tsReportInfoSpan'>
                                                                            {(item.accountCostCenter != null) ? item.partyName + ' • ' + item.projectName + ' • ' + item.accountCostCenter :
                                                                                item.partyName + ' • ' + item.projectName}
                                                                        </span>
                                                                        </>
                                                                    )}
                                                                    </>
                                                                )}
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td className='tsReportInfoTbody'>
                                                            <span className="task projectTaskHeading">
                                                                {/* {t('Total')} */}
                                                                {getValueFromResource('Total', dispatch, t)}
                                                            </span>
                                                        </td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                        <div className={"datePanel tableContainerCol"}>
                                            <table id='tblHoursInput' className={"table data-table"} >
                                                <thead>
                                                    <tr>
                                                        {timeEntriesDetail.dateHeaderArray.length > 0 && timeEntriesDetail.dateHeaderArray.map((item: any, index: number) => {
                                                            return (
                                                                <th style={{ backgroundColor: '#f0f1f4', color: '#172b4d', fontWeight: 600, fontSize: 12, textTransform: "uppercase" }}>
                                                                    <div>
                                                                        <div>
                                                                            <span>{item.split('<br>')[0]}</span>
                                                                        </div>
                                                                        <span className='tsHeaderDateLabel'>{item.split('<br>')[1]}</span>
                                                                    </div>
                                                                </th>
                                                            )
                                                        })}
                                                        <th style={{ backgroundColor: '#f0f1f4', color: '#172b4d', fontWeight: 600, fontSize: 12, textTransform: "uppercase", verticalAlign: 'middle' }}>
                                                            <span>Total</span>
                                                        </th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {timeEntriesDetail.timeEntryDetailArray.length > 0 && timeEntriesDetail.timeEntryDetailArray.map((item: any, index: number) => (
                                                        <tr key={index} className='timesheet-row'>
                                                            {item.timeEntries.map((items: any, b: number) =>
                                                                <>
                                                                    <td style={{ height: 56, padding: 0, verticalAlign: 'middle', border: '0.6px solid #f2f2f2', color: '#172b4d', fontWeight: 600, fontSize: 15 }}>
                                                                        <span className='duration-value'>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (items.Hours), 2): displayValueForTimeEntry(items.Hours, isTimesheetPolicy, decimalFormat)}</span></td>
                                                                </>
                                                            )}
                                                            <td style={{ height: 56, padding: 0, verticalAlign: 'middle', border: '0.6px solid #f2f2f2', color: '#172b4d', fontWeight: 600, fontSize: 15 }}>
                                                                <span className='duration-value'>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (timeEntriesDetail.timeEntryDetailArray.find((x: any) => x.rowId == item?.rowId)?.totalHours), 2):displayValueForTimeEntry(timeEntriesDetail.timeEntryDetailArray.find((x: any) => x.rowId == item?.rowId)?.totalHours, isTimesheetPolicy, decimalFormat)}</span>
                                                            </td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                                {
                                                    timeEntriesDetail.timeEntryDetailArray.length > 0 &&
                                                    <tfoot>
                                                        <tr className={"timesheet-row total-row dark"}>
                                                            {getColumnSum(timeEntriesDetail.timeEntryDetailArray, showTimeOffInTimesheet).map((x, i) =>
                                                                <td key={i} style={{ padding: 0 }}>
                                                                    <div className='tsDetailTableFooter'>
                                                                        <span className={"footer-duration-value"}>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), x, 2):displayValueForTimeEntry(x, isTimesheetPolicy, decimalFormat)}</span>
                                                                    </div>
                                                                </td>)}
                                                            <td style={{ padding: 0 }}>
                                                                <div className='tsDetailTableFooter'>
                                                                    <span className={"footer-duration-value"}>
                                                                        {decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), ( timeEntriesDetail.timeEntryDetailArray.reduce((sum: number, item: any) => sum + (item.totalHours || 0), 0)), 2)
                                                                        : displayValueForTimeEntry(
                                                                            timeEntriesDetail.timeEntryDetailArray.reduce((sum: number, item: any) => sum + (item.totalHours || 0), 0),
                                                                            isTimesheetPolicy,
                                                                            decimalFormat
                                                                        )}
                                                                    </span>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    </tfoot>
                                                }
                                            </table>
                                        </div>
                                    </div>
                                    <div className='mb-1'>
                                        <div className='commentHeading'>
                                            {/* {t('Comments List')} */}
                                            {getValueFromResource('Comments List', dispatch, t)}
                                        </div>
                                    </div>
                                    <table className='tsReportCommentTable'>
                                        <thead>
                                            <tr className='tsReportCommentThead'>
                                                {/* <th style={{ paddingLeft: 10, width: '35%' }}> {t('Project Name • Task Name')}</th>
                                                <th style={{ width: '20%' }}>{t('Time Entry Date')}</th>
                                                <th style={{ width: '20%' }}>{t('Total Time')} </th> */}
                                                <th style={{ paddingLeft: 10 }}>
                                                    {/* {t('Project Name • Task Name')} */}
                                                    {getValueFromResource('Project Name • Task Name', dispatch, t)}

                                                </th>
                                                <th>
                                                    {/* {t('Time Entry Date')} */}
                                                    {getValueFromResource('Time Entry Date', dispatch, t)}
                                                </th>
                                                <th>
                                                    {/* {t('Total Time')} */}
                                                    {getValueFromResource('Total Time', dispatch, t)}
                                                </th>
                                                <th>
                                                    {/* {t('Description')} */}
                                                    {getValueFromResource('Description', dispatch, t)}
                                                </th>
                                                {
                                                    captionFieldsArray != undefined && captionFieldsArray.map((item: any, index: any) => {
                                                        return (
                                                            <th>
                                                                {Object.values(item)}
                                                            </th>
                                                        )
                                                    })
                                                }
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {timeEntriesDetail.commentsArray.length > 0 && timeEntriesDetail.commentsArray.map((item: any, index: number) => {
                                                let count = 1;
                                                return (
                                                    <tr key={index} className='tsReportCommentTbody'>
                                                        {(item.AccountTimeOffType != null && item.IsTimeOff === true) ? (
                                                            <td style={{ paddingLeft: 10 }}>
                                                                {/* {t('Time Off •')}  */}
                                                                {getValueFromResource('Time Off •', dispatch, t)}
                                                                {item.AccountTimeOffType}</td>
                                                        ) : (
                                                            <td style={{ paddingLeft: 10 }}>{item.ProjectName + ' • ' + item.TaskName}</td>
                                                        )}
                                                        {/* <td>{moment.parseZone(item.TimeEntryDate).format('YYYY-MM-DD')}</td> */}
                                                        <td>{formatDateWithDateAndMonthName(item.TimeEntryDate, cultureInfoName.toString())}</td>
                                                        
                                                        <td>{decimalFormat ? FormatInvoiceDecimalNumber(cultureInfoName.toString(), (item.Hours), 2) :item.FormattedTotalTime}</td>
                                                        <td>{item.Description}</td>
{/*                                                         {captionFieldsArray != undefined && Object.keys(item).map((key) => {
                                                            if (key.startsWith('CustomField') && count <= captionFieldsArray.length) {
                                                                count = count + 1;
                                                                return <td key={key}>{item[key]}</td>;
                                                            }
                                                            return null;
                                                        })} */}
                                                        {captionFieldsArray != undefined && Object.keys(item)
                                                            .filter(key => key.startsWith('CustomField'))
                                                            .map((key, index) => {
                                                                if (index >= captionFieldsArray.length) return null;

                                                                const formattedValue = getAndSetCustomFieldValues(key, item[key], customFieldsArray, cultureInfoName.toString(), decimalPlaces);
                                                            

                                                                return <td key={key}>{formattedValue}</td>;
                                                            })
}
                                                    </tr>
                                                )
                                            })}
                                        </tbody>
                                    </table>
                                    {timeEntriesDetail.commentsArray.length === 0 &&
                                        <div className=''>
                                            <p className='noDataFound mt-3'>
                                                {/* {t('No Record Found')} */}
                                                {getValueFromResource('No Record Found', dispatch, t)}
                                            </p>
                                        </div>
                                    }
                                </>}
                        </div>
                        <div className="modal-footer">
                            <a onClick={() => { handlePrint() }} className={"btn btn-primary btn-sm "}>
                                <i className="bi bi-printer fs-5 me-1"></i>
                                {/* {t('Print Timesheet')} */}
                                {getValueFromResource('Print Timesheet', dispatch, t)}
                            </a>
                        </div>
                    </div>
                </div>
                <div style={{ display: 'none' }}> <TimesheetPrintWidget ref={componentRef}  {...timeEntriesDetail} isForTimesheet={isForTimesheet} customFieldsArray={customFieldsArray} /></div>
            </div>
        </>
    )
}

export default TimesheetPrintViewWidget